<highcharts-chart 
    *ngIf="hasData"
    [options]="chartOptions" 
    [Highcharts]="Highcharts">
</highcharts-chart>
